import Echo from 'laravel-echo'
import Pusher from 'pusher-js'
import http from '@/api/http'

let echo = null

export function initEcho() {

    if (echo) {
        return echo
    }

    // Temps réel optionnel : désactivé si Reverb n'est pas configuré (développement local).
    if (!process.env.VUE_APP_REVERB_APP_KEY) {
        return null
    }

    window.Pusher = Pusher

    echo = new Echo({

        broadcaster: 'reverb',

        key: process.env.VUE_APP_REVERB_APP_KEY,

        wsHost: process.env.VUE_APP_REVERB_HOST,

        wsPort: Number(
            process.env.VUE_APP_REVERB_PORT
        ),

        wssPort: Number(
            process.env.VUE_APP_REVERB_PORT
        ),

        forceTLS: process.env.VUE_APP_REVERB_SCHEME === 'https',

        enabledTransports: [
            'ws',
            'wss'
        ],

        authEndpoint:
            process.env.VUE_APP_BASE_URL +
            'broadcasting/auth',

        authorizer: (channel) => {

            return {

                authorize: (socketId, callback) => {

                    http.post(
                        'broadcasting/auth',
                        {
                            socket_id: socketId,
                            channel_name: channel.name
                        }
                    )
                    .then(response => {

                        callback(
                            null,
                            response.data
                        )
                    })
                    .catch(error => {

                        callback(error)
                    })
                }
            }
        },

        withCredentials: true,
    })

    return echo
}

export default initEcho